// @ts-ignore
import currencyFormatter from 'currency-formatter'
import { cpf, cnpj } from 'cpf-cnpj-validator'
// show what props are the minimal to get account setup
export const baseAccountData = {
  nationalRegistration: '',
  accountOwner: '',
  bank: '',
  agency: '',
  accountType: '',
  accountNumber: '',
  accountDigit: '',
  accountIdentifier: '',
  transactionType: '',
}

export const baseAccountPixData = {
  accountOwner: '',
  nationalRegistration: '',
  pixKey: '',
  pixtypeKey: '',
  transactionType: '',
}

// control account button status
export const hasEmptyProperty = (obj: any): boolean => {
  const hasValue = Object.keys(baseAccountData).filter((key) => {
    return (obj[key] as any) === ''
  })
  if (hasValue[0] === undefined) return true
  if (hasValue[0] !== undefined) return false
  return false
}

export const hasEmptyPixProperty = (obj: any): boolean => {
  const hasValue = Object.keys(baseAccountPixData).filter((key) => {
    return (obj[key] as any) === ''
  })
  if (hasValue[0] === undefined) return true
  if (hasValue[0] !== undefined) return false
  return false
}

export const getBankName = (value: string, bankList: any) => {
  let name = ''
  const returnedName = bankList.filter((bank: any) => value === bank.value)[0]
    ?.label
  if (returnedName !== undefined) return (name = returnedName)
  return name
}

export const handlerSetBankAccount = (account: any, formikHook: any) => {
  const isPix = account.transactionType === 'PIX'

  formikHook.setFieldValue('transactionType', account.transactionType)
  formikHook.setFieldValue('nationalRegistration', account.nationalRegistration)
  formikHook.setFieldValue('accountOwner', account.accountOwner)
  formikHook.setFieldValue('pixKey', account.pixKey)
  formikHook.setFieldValue('pixTypeKey', account.pixKeyType)
  if (!isPix) {
    formikHook.setFieldValue('bank', account.bank)
    formikHook.setFieldValue('agency', account.agency)
    formikHook.setFieldValue('accountDigit', account.accountDigit)
    formikHook.setFieldValue('accountType', account.accountType)
    formikHook.setFieldValue('accountNumber', account.accountNumber)
    formikHook.setFieldValue('accountIdentifier', account.accountIdentifier)
  } else {
    formikHook.setFieldValue('bank', '')
    formikHook.setFieldValue('agency', '')
    formikHook.setFieldValue('accountType', '')
    formikHook.setFieldValue('accountNumber', '')
    formikHook.setFieldValue('accountIdentifier', '')
  }
}

// cleanup the accounts fields to show form account
export const clearAccountsFieldsUntouched = (formikHook: any): void => {
  formikHook.setFieldValue('nationalRegistration', '')
  formikHook.setFieldValue('accountOwner', '')
  formikHook.setFieldValue('bank', '')
  formikHook.setFieldValue('agency', '')
  formikHook.setFieldValue('accountType', '')
  formikHook.setFieldValue('accountNumber', '')
  formikHook.setFieldValue('accountDigit', '')
  formikHook.setFieldValue('accountIdentifier', '')
  formikHook.setFieldValue('transactionType', '')
  formikHook.setFieldValue('pixKey', '')
  formikHook.setFieldValue('pixTypeKey', '')
}

// cleanup touched status for account fields
export const setAccountsFieldsUntouched = (formikHook: any): void => {
  formikHook.setFieldTouched('nationalRegistration', false)
  formikHook.setFieldTouched('accountOwner', false)
  formikHook.setFieldTouched('bank', false)
  formikHook.setFieldTouched('agency', false)
  formikHook.setFieldTouched('accountType', false)
  formikHook.setFieldTouched('accountNumber', false)
  formikHook.setFieldTouched('accountDigit', false)
  formikHook.setFieldTouched('accountIdentifier', false)
  formikHook.setFieldTouched('transactionType', false)
  formikHook.setFieldTouched('pixKey', false)
  formikHook.setFieldTouched('pixTypeKey', false)
}

export const formatCpfCnpj = (valor: string): string => {
  const apenasDigitos = valor.replace(/\D/g, '')
  if (cpf.isValid(apenasDigitos)) {
    return cpf.format(apenasDigitos)
  } else {
    return cnpj.format(apenasDigitos)
  }
}

export const cpfCNPJSanitazer = (valor: string): string => {
  return valor.replace(/\D/g, '')
}

export const StepInfoData = (currentStep: number) => {
  if (currentStep === 1) return 'Passo 01.'
  if (currentStep === 2) return 'Passo 02.'
  if (currentStep === 3) return 'Passo 03.'
}

export const formatDecimal = (numero: string): string => {
  if (numero.includes('.')) {
    const partes = numero.split('.')
    let parteInteira = partes[0]
    let parteDecimal = partes[1]
    if (parteDecimal.length === 1) {
      parteDecimal += '0'
    }
    return `${parteInteira}.${parteDecimal.substring(0, 2)}`
  }
  return numero
}
export const formatReal = (numero: string): string => {
  let value: any = Number(numero)
  if (numero.indexOf(',') === -1) {
    value = currencyFormatter.format(Number(numero), { code: 'BRL' })
    return value
  } else {
    return 'R$ ' + numero
  }
}

export const hasArrayFullFilled = (arr: string[]): boolean => {
  return arr.every((item) => item !== '')
}
